import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import AboutHero from './components/AboutHero';
import StatStrip from './components/StatStrip';
import MissionSection from './components/MissionSection';
import ProblemSection from './components/ProblemSection';
import HowItWorks from './components/HowItWorks';
import FeaturesSection from './components/FeaturesSection';
import OfferGrid from './components/OfferGrid';
import ValuesSection from './components/ValuesSection';
import TestimonialsSection from './components/TestimonialsSection';
import PressSection from './components/PressSection';
import CTASection from './components/CTASection';
import PartnersSection from '../Home/components/PartnersSection';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#FFFFFF',
    '& .reveal': {
      opacity: 0,
      transform: 'translateY(22px)',
      transition: 'opacity 0.65s ease, transform 0.65s ease',
    },
    '& .reveal.in': {
      opacity: 1,
      transform: 'none',
    },
    '& .d1': { transitionDelay: '0.08s' },
    '& .d2': { transitionDelay: '0.16s' },
    '& .d3': { transitionDelay: '0.24s' },
    '& .d4': { transitionDelay: '0.32s' },
  },
}));

const About = () => {
  const classes = useStyles();

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.reveal');
    elements.forEach((el) => obs.observe(el));

    return () => {
      elements.forEach((el) => obs.unobserve(el));
    };
  }, []);

  return (
    <div className={classes.root}>
      <HubNav />
      <PageHeaders
        title="About Plootus - Our Mission to Simplify Retirement Planning"
        description="Learn about Plootus, our mission to make retirement planning accessible, and our team of financial experts dedicated to your financial success."
        keywords="about Plootus, company mission, retirement planning company, financial planning team, our story"
        canonicalUrl="https://www.plootus.com/about"
      />
      <AboutHero />
      <StatStrip />
      <MissionSection />
      <ProblemSection />
      <HowItWorks />
      <FeaturesSection />
      <OfferGrid />
      <ValuesSection />
      <PartnersSection
        isAboutPage={true}
        titleFontSize="clamp(1.85rem, 3vw, 2.6rem)"
        titleFontWeight={800}
        titleColor="#1A2B4A"
        titleLineHeight={1.15}
        titleLetterSpacing="-0.4px"
        subtitleFontSize="0.95rem"
        subtitleColor="#444F5E"
        platformLinkColor="#3B5FDB"
      />
      <TestimonialsSection />
      <PressSection />
      <CTASection />
    </div>
  );
};

export default About;
